import Filter from './Filter'

export default class Inbox extends Filter {
    filterComponent = import('@/views/components/filters/compoents/InboxFilterComponent.vue')

    static LETTER_TYPE = 'letter_type'

    static LETTER_STATUS = 'letter_status'

    static PERIOD = 'period'

    static FROM_ORG = 'from_org'

    fields = {
      [Inbox.LETTER_TYPE]: {
        label: 'Letter Type',
      },
      [Inbox.LETTER_STATUS]: {
        label: 'Letter Status',
      },
      [Inbox.PERIOD]: {
        label: 'Period',
      },
      [Inbox.FROM_ORG]: {
        label: 'From Org',
      },
    }
}
